import { SelectOption } from 'global';

export enum DealerTier {
  Platinum = 'PLATINUM',
  Gold = 'GOLD',
  NonQualified = 'NON_QUALIFIED',
}

export const DEALER_TIER_LABELS: Record<DealerTier, string> = {
  [DealerTier.Platinum]: 'Platinum',
  [DealerTier.Gold]: 'Gold',
  [DealerTier.NonQualified]: 'Non-Qualified',
};

export const DEALER_TIER_OPTIONS: SelectOption<DealerTier>[] = [
  { value: DealerTier.Platinum, label: 'Platinum' },
  { value: DealerTier.Gold, label: 'Gold' },
  { value: DealerTier.NonQualified, label: 'Non-Qualified' },
];
